export const CAMPO_OBRIGATORIO = 'O preencimento deste campo é obrigatorio';
